module.exports = __webpack_public_path__ + "static/media/sikom-white.e84d6ceb.png";